import React from 'react';
import { useTranslation } from 'react-i18next';

const Legend: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="legend-container">
            <label className="title">{t('researchArea')}:</label>
            <label className="label"><i className="icon-digital"></i> {t('Digitale Welt')}</label>
            <label className="label"><i className="icon-energy"></i> {t('Energie und Umwelt')}</label>
            <label className="label"><i className="icon-life"></i> {t('Life Sciences')}</label>
            <label className="label"><i className="icon-manufacture"></i> {t('Fertigungsprozesse und Materialien')}
            </label>
            <label className="label"><i className="icon-space"></i> {t('Space Sciences')}
            </label>
        </div>
    );
};

export default Legend;